export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 3_05.1b750ba5.jpg";